import styled from 'styled-components';
import { Link } from 'react-scroll';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.theme.accent.secondary}90;
  right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;

export const Panel = styled.aside`
  @media screen and (max-width: 768px) {
    position: fixed;
    width: 70%;
    background: ${(p) => p.theme.background};
    display: grid;
    align-items: center;
    transition: 0.2s ease-in-out;
    overflow: hidden;
    right: ${(p) => (p.isOpen ? '0' : '-100%')};
    height: 100%;
    top: 0;
    z-index: 105;
    box-shadow: -3px 0px 500px 50px ${(p) => p.theme.components}70;
    border-left: 3px solid ${(p) => p.theme.accent.secondary}99;
  }
`;

export const Menu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(5, 80px);
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;

  @media screen and (max-width: 360px) {
    grid-template-rows: repeat(5, 60px);
  }
`;

export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  list-style: none;
  outline: none;
  transition: 0.2s ease-in-out;
  color: ${(p) => p.theme.accent.secondary};
  cursor: pointer;

  &:hover {
    filter: brightness(170%);
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
